import { Provider } from 'react-redux';
import store from './store';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { initGA } from "./analytics";
import LandingHeader from './LandingHeader';
import Footer from './Footer';
import HeroImage from './HeroImage';
import MenuPage from './MenuPage';
import AboutPage from './AboutPage';
import Gallery from './Gallery';
import AdminPage from './AdminPage';
import AdminLogin from './AdminLogin';
import React, { useEffect } from "react";

// 🆕 Import these
import MenuPageOrder from './MenuPageOrder';  // replace with actual filename if different
import OrderSummary from './OrderSummary';    // replace with actual filename if different
import AdminRegister from './AdminRegister';
import ProtectedRoute from "./ProtectedRoute";
import ContactPage from './ContactPage';
import GAListener from './GAListener';
import NiblLanding from './DelioLanding';

function App() {
  useEffect(() => {
    initGA(); // Initialize GA once
      console.log("Google Analytics initialized"); // ✅ Log to confirm

  }, []);
  return (
    <Provider store={store}>
      <Router>
        <GAListener />
        <Routes>
          <Route
            path="/"
            element={
              <>
              <NiblLanding/>
              </>
            }
          />
          <Route
            path="/menu"
            element={
              <>
                <LandingHeader />
                <HeroImage height="20vh" />
                <MenuPage />
                <Footer />
              </>
            }
          />
          <Route
            path="/contact-us"
            element={
              <>
                <LandingHeader />
                <HeroImage height="20vh" />
                <ContactPage />
                <Footer />
              </>
            }
          />
          <Route
            path="/about"
            element={
              <>
                <LandingHeader />

                <HeroImage height="20vh" />
                <AboutPage />
                <Footer />
              </>
            }
          />
          <Route
            path="/admin-login"
            element={<AdminLogin />}
          />
          <Route
            path="/admin"
            element={<ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>}
          />
          <Route
            path="/admin-register"
            element={<AdminRegister />}
          />
          <Route
            path="/reserve"
            element={
              <>
                <LandingHeader />

                <HeroImage height="20vh" />
                <Gallery />
                <Footer />
              </>
            }
          />

          {/* 🆕 Menu Order Page */}
          <Route
            path="/menu-order"
            element={
              <>
                <LandingHeader />

                <HeroImage height="20vh" />
                <MenuPageOrder />
                <Footer />
              </>
            }
          />

          {/* 🆕 Order Summary Page */}
          <Route
            path="/order-summary"
            element={
              <>
                <LandingHeader />

                <HeroImage height="20vh" />
                <OrderSummary />
                <Footer />
              </>
            }
          />

         

          {/* 🆕 Axios API Learning with Fill-in-the-Blanks Game */}
         
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
